'use strict'

function _typeof(obj) {
  '@babel/helpers - typeof'
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }
  return _typeof(obj)
}

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.UploadField = exports.PrintedUploadField = void 0

var _react = _interopRequireWildcard(require('react'))

var _styledComponents = _interopRequireDefault(require('styled-components'))

var _index = require('../../atoms/Button/index.js')

var _index2 = require('../../atoms/Label/index.js')

var _index3 = require('../../atoms/Typography/index.js')

var _index4 = require('../Flex/index.js')

var _templateObject, _templateObject2, _templateObject3, _templateObject4

var _excluded = [
  'id',
  'label',
  'error',
  'margin',
  'required',
  'disabled',
  'tabIndex',
  'onSave',
  'exists',
  'inputClassName',
]

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null
  var cacheBabelInterop = new WeakMap()
  var cacheNodeInterop = new WeakMap()
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop
  })(nodeInterop)
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj }
  }
  var cache = _getRequireWildcardCache(nodeInterop)
  if (cache && cache.has(obj)) {
    return cache.get(obj)
  }
  var newObj = {}
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc)
      } else {
        newObj[key] = obj[key]
      }
    }
  }
  newObj['default'] = obj
  if (cache) {
    cache.set(obj, newObj)
  }
  return newObj
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg)
    var value = info.value
  } catch (error) {
    reject(error)
    return
  }
  if (info.done) {
    resolve(value)
  } else {
    Promise.resolve(value).then(_next, _throw)
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args)
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value)
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err)
      }
      _next(undefined)
    })
  }
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  )
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  )
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen)
  var n = Object.prototype.toString.call(o).slice(8, -1)
  if (n === 'Object' && o.constructor) n = o.constructor.name
  if (n === 'Map' || n === 'Set') return Array.from(o)
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen)
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i]
  }
  return arr2
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator']
  if (_i == null) return
  var _arr = []
  var _n = true
  var _d = false
  var _s, _e
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value)
      if (i && _arr.length === i) break
    }
  } catch (err) {
    _d = true
    _e = err
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']()
    } finally {
      if (_d) throw _e
    }
  }
  return _arr
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

var UploadField = function UploadField(_ref) {
  var id = _ref.id,
    label = _ref.label,
    error = _ref.error,
    margin = _ref.margin,
    required = _ref.required,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    onSave = _ref.onSave,
    exists = _ref.exists,
    inputClassName = _ref.inputClassName,
    props = _objectWithoutProperties(_ref, _excluded)

  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1]

  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    saved = _useState4[0],
    setSaved = _useState4[1]

  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1]

  var saveField = /*#__PURE__*/ (function () {
    var _ref2 = _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee(event) {
        var _event$target$files

        var _file

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch ((_context.prev = _context.next)) {
              case 0:
                setSaving(true) // do saving

                if (
                  !(
                    (_event$target$files = event.target.files) !== null &&
                    _event$target$files !== void 0 &&
                    _event$target$files.length
                  )
                ) {
                  _context.next = 8
                  break
                }

                _file = event.target.files[0]
                _context.t0 = onSave

                if (!_context.t0) {
                  _context.next = 7
                  break
                }

                _context.next = 7
                return onSave(_file)

              case 7:
                setFile(_file)

              case 8:
                setSaving(false)
                setSaved(true)

              case 10:
              case 'end':
                return _context.stop()
            }
          }
        }, _callee)
      })
    )

    return function saveField(_x) {
      return _ref2.apply(this, arguments)
    }
  })()

  var inputText = exists
    ? 'File Saved ✓'
    : file
    ? ''.concat(file === null || file === void 0 ? void 0 : file.name, ' \u2713')
    : 'Upload / Take Photo'
  return /*#__PURE__*/ _react['default'].createElement(
    _index4.Flex,
    {
      flex: '1',
      flexDirection: 'column',
      margin: margin,
    },
    /*#__PURE__*/ _react['default'].createElement(
      _index2.Label,
      {
        className: 'fs-unmask',
        htmlFor: id,
        error: !!error,
        required: required,
        disabled: disabled,
      },
      label
    ),
    /*#__PURE__*/ _react['default'].createElement(
      FieldContainer,
      {
        className: inputClassName,
      },
      /*#__PURE__*/ _react['default'].createElement(
        InputContainer,
        null,
        /*#__PURE__*/ _react['default'].createElement(
          _index.Button,
          {
            tabIndex: -1,
            disabled: saving,
            loading: saving,
            color: saved || exists ? 'success' : 'primary',
            variant: 'filled',
          },
          inputText
        ),
        /*#__PURE__*/ _react['default'].createElement(
          _index3.Typography,
          {
            as: 'label',
            margin: '0 0 0 1',
            color: error ? 'error' : 'text',
          },
          error ||
            (!file && !exists && 'Please make sure the document fills the content of the image')
        )
      ),
      /*#__PURE__*/ _react['default'].createElement(
        FileInput,
        _extends(
          {
            tabIndex: -1,
            disabled: saving || disabled,
            type: 'file',
            accept: 'image/x-png,image/gif,image/jpeg',
            onChange: saveField,
            title: inputText,
          },
          props
        )
      )
    )
  )
}

exports.UploadField = UploadField

var FieldContainer = _styledComponents['default'].div(
  _templateObject || (_templateObject = _taggedTemplateLiteral(['\n  position: relative;\n']))
)

var InputContainer = _styledComponents['default'].div(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n\n  min-width: 125px;\n']))
)

var FileInput = _styledComponents['default'].input(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteral([
      '\n  height: 45px;\n  position: absolute;\n  top: 0;\n  opacity: 0;\n  outline: 1px solid black;\n  cursor: pointer;\n',
    ]))
)

var PrintedUploadField = function PrintedUploadField(_ref3) {
  var label = _ref3.label,
    url = _ref3.url

  var onImageLoad = function onImageLoad(e) {
    var img = e.currentTarget
    console.log(img.naturalWidth)
    console.log(img.naturalHeight)

    if (img.naturalHeight > img.naturalWidth) {
      img.style.transformOrigin = 'center center'
      img.style.transform = 'rotate(90deg)'
    }
  }

  return /*#__PURE__*/ _react['default'].createElement(
    _react['default'].Fragment,
    null,
    /*#__PURE__*/ _react['default'].createElement(
      _index4.Flex,
      {
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        margin: '12px 0 0 0',
      },
      /*#__PURE__*/ _react['default'].createElement(_index2.Label, null, label, ':'),
      /*#__PURE__*/ _react['default'].createElement(UploadedImage, {
        onLoad: onImageLoad,
        src: url,
        alt: 'patient upload',
      })
    )
  )
}

exports.PrintedUploadField = PrintedUploadField

var UploadedImage = _styledComponents['default'].img(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteral(['\n  height: 60mm;\n  object-fit: contain;\n']))
)
